export default __webpack_public_path__ + "static/media/linter-guide.6cd10d9a.png";